import { useTranslation } from "react-i18next"
import { useAppSelector } from "@/store"
import { RealtimeSelectors } from "@/store/slices/realtime"
import styles from "./ConnectionOverlay.module.scss"

export const ConnectionOverlay = () => {
  const { t } = useTranslation()
  const status = useAppSelector(RealtimeSelectors.selectConnectionStatus())

  if (status !== "reconnecting") {
    return null
  }

  return (
    <div className={styles.connectionOverlay} role="status">
      {t("common.loading")}
    </div>
  )
}
